import gql from 'graphql-tag';
export const QUERY_LONGTAIL_PROPERTIES_TOTAL_COUNT = gql`
  query CMS_LongtailTotal($landlordSlug: String) {
    properties(landlordSlug: $landlordSlug, bookingJourneys: [SEMI_AUTOMATIC, INSTANT_BOOK]) {
      totalCount
    }
  }
`;

export const MUTATION_CREATE_LANDLORD_SUBSCRIPTION = gql`
  mutation CMS_CreateLandlordSubscription($input: CreateLandlordSubscriptionInput!) {
    createLandlordSubscription(input: $input) {
      name
      callbackUrl
    }
  }
`;

export const MUTATION_UPDATE_LANDLORD_SUBSCRIPTION = gql`
  mutation CMS_UpdateLandlordSubscription($input: UpdateLandlordSubscriptionInput!) {
    updateLandlordSubscription(input: $input) {
      name
      callbackUrl
    }
  }
`;

export const QUERY_LIST_PMS = gql`
  query CMS_QueryListPMS {
    listPMS {
      pms {
        name
        id
        status
      }
    }
  }
`;

export const MUTATION_UPDATE_PMS_LANDLORD = gql`
  mutation CMS_UpdatePMSLandlord($input: UpdatePMSLandlordInput!) {
    updatePMSLandlord(input: $input) {
      landlord {
        id
      }
    }
  }
`;

export const MUTATION_ISSUE_INTEGRATION_WITH_PMS = gql`
  mutation CMS_IssueIntegrationWithPMS($input: IssueIntegrationWithPMSInput!) {
    issueIntegrationWithPMS(input: $input) {
      activationToken
    }
  }
`;
